module.exports = __webpack_public_path__ + "static/media/madelaine_laine-IG-2.00c36def.PNG";